import styled from "@emotion/styled";

export const Anchor = styled.div`
  position: relative;
  margin-left: -10px;
`;

export const Container = styled.div<{
  isVisible: boolean;
  showCalendar: boolean;
}>`
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(220, 223, 228, 1);
  border-radius: 12px;
  box-shadow:
    0px 2px 8px rgba(0, 0, 0, 0.06),
    0px 16px 64px -12px rgba(0, 0, 0, 0.1);
  position: absolute;
  bottom: 20px;
  right: 0;
  padding: 8px;
  transition:
    height ${({ showCalendar }) => (showCalendar ? 240 : 140)}ms ease-in-out,
    opacity 140ms ease-in-out;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  pointer-events: ${({ isVisible }) => (isVisible ? "auto" : "none")};
  height: ${({ isVisible, showCalendar }) =>
    isVisible ? (showCalendar ? 313 : 88) : 0}px;
  overflow: hidden;
`;
